module.exports = __webpack_public_path__ + "img/ic-ads-acc-emedia.ea5a7b85.svg";